import React from "react";
import {observer} from "mobx-react";

import "./legend-layer.scss";


import {TopicConfiguration} from "../../../../config/topic-configuration";
import {LegendLayerInfoConfiguration} from "../../../../config/legend-configuration";
import {Header} from "semantic-ui-react";
import {LegendItemGroup} from "./legend-item-group/legend-item-group";

interface LegendLayerProps {
    topic: TopicConfiguration;
    config: LegendLayerInfoConfiguration;
}

@observer
export class LegendLayer extends React.Component<LegendLayerProps, any> {

    constructor(props: LegendLayerProps) {
        super(props);
    }

    componentDidMount(): void {
    }

    componentWillUnmount(): void {
    }

    render(): JSX.Element | null {
        if (!this.props.topic) {
            // no topic selected
            return <span className={"info"}>Kein Fachgebiet gewählt...</span>;
        }

        const itemGroups = this.props.config.itemGroups.filter((group) =>
            group.topics.includes(this.props.topic.id));

        if (!itemGroups.length) {
            return null;
        }

        const groups = itemGroups.map((group) => <LegendItemGroup config={group} key={group.id}/>);

        return (
            <div className="geo-legend-layer">
                {groups.length &&
                    <Header className="geo-legend-layer-heading" size="small">
                        {this.props.config.title}
                    </Header>
                }
                {groups}
            </div>
        );

    }
}
